export default function SvgInfos2() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        cursor="pointer"
        viewBox="0 0 512 512"
        fill="#fff"
      >
      <path
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M220 220L252 220 252 336"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M208 340L296 340"
      ></path>
      <path d="M248 130a26 26 0 1026 26 26 26 0 00-26-26z"></path>
    </svg>
    </>
  );
}
